export type DateRangeType = [Date | null, Date | null];
